// extracted by mini-css-extract-plugin
module.exports = {"parent":"Cloud_parent__1J6aO","flex":"Cloud_flex__1-dCA"};